import { theme } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { Empty, Flex, Typography } from 'zui/Antd';
import { selectPeopleByPersonID } from 'reduxStore/people/selectors';
import { selectCredentialByID } from 'reduxStore/credentials/selectors';

const { Text } = Typography;

const CredentialHoldersContent = ({ credentialID }) => {
	const {
		token: {
			fontWeightStrong,
			paddingSM,
			colorBgLayout,
			borderRadius,
			colorBorderSecondary,
			fontSizeLG,
			paddingXS,
			fontSizeSM,
			colorTextLabel
		}
	} = theme.useToken();

	const credential = useSelector((state) => selectCredentialByID(state, credentialID));
	const person = useSelector((state) => selectPeopleByPersonID(state, credential?.personID));

	if (!credential?.personID || !person) {
		return (
			<Flex vertical gap={paddingXS} style={{ width: '100%' }}>
				<Flex justify='center' align='center' style={{ width: '100%' }}>
					<Empty description='No credential holder assigned' image={Empty.PRESENTED_IMAGE_SIMPLE} />
				</Flex>
			</Flex>
		);
	}

	return (
		<Flex vertical gap={paddingXS} style={{ width: '100%' }}>
			<Flex
				vertical
				style={{
					width: '100%',
					boxSizing: 'border-box',
					backgroundColor: colorBgLayout,
					borderRadius,
					border: `1px solid ${colorBorderSecondary}`,
					padding: paddingSM
				}}
			>
				<Flex justify='space-between' align='center' style={{ width: '100%', gap: paddingXS }}>
					<Text
						style={{
							color: colorTextLabel,
							fontSize: fontSizeLG,
							fontWeight: fontWeightStrong,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap'
						}}
						title={person?.displayName || person?.name || 'Unknown'}
					>
						{person?.displayName || person?.name || 'Unknown'}
					</Text>
				</Flex>

				<Flex justify='space-between' align='center' style={{ width: '100%', gap: paddingXS }}>
					<Text
						style={{
							fontSize: fontSizeSM,
							color: colorTextLabel,
							fontWeight: 500,
							overflow: 'hidden',
							textOverflow: 'ellipsis',
							whiteSpace: 'nowrap'
						}}
						title={person?.email || '-'}
					>
						{person?.email || '-'}
					</Text>
				</Flex>

				{person?.phone && (
					<Flex style={{ width: '100%', marginTop: paddingXS }}>
						<Text
							style={{
								fontSize: fontSizeSM,
								color: colorTextLabel,
								fontWeight: 400
							}}
							title={person?.phone}
						>
							{person?.phone}
						</Text>
					</Flex>
				)}
			</Flex>
		</Flex>
	);
};

export default CredentialHoldersContent;
